import Axios from './Axios';

const API_URL = '/email-templates';

export const emailTemplatesS = {
    get: () => Axios.get(API_URL),
    add: (payload) => Axios.post(API_URL, payload), 
    edit: (payload) => Axios.put(API_URL + '/'+payload.id, payload)
};



